module.exports = __webpack_public_path__ + "img/checkedRotate.00e73d7f.png";